<!-- Page header -->
<div class="np-page-header">
  <button pButton type="button" class="p-button-text p-button-sm" title="Back to batch" (click)="goBack()">
    <i class="pi pi-arrow-left"></i>
  </button>
  <span class="np-page-title">Pull Item</span>
</div>

<div *ngIf="isPageReady" class="p-3 flex flex-col gap-3 h-full">
  <!-- JO Detail summary -->
  <div class="np-card flex flex-col gap-2">
    <div class="flex items-center justify-between gap-2">
      <div class="text-sm opacity-70">JO {{ joDetail.joHeaderId }} · Detail {{ joDetail.id }}</div>
      <span class="np-badge np-badge-await">
        {{ qtyApplied }} / {{ joDetail.orderQty }} applied
      </span>
    </div>
    <div class="flex flex-col gap-0.5">
      <div class="font-semibold text-base">
        {{ joDetail.product?.productType?.manufacturer?.name }}
        <span class="opacity-50">·</span>
        {{ joDetail.product?.productType?.style }}
      </div>
      <div class="text-sm">{{ joDetail.product?.productType?.description }}</div>
      <div class="text-xs opacity-70">{{ joDetail.product?.featureChoicesExtract }}</div>
    </div>
  </div>

  <!-- Scanner card -->
  <div class="np-card flex flex-col gap-2">
    <uni-scanner-input
      label="Scan item barcode"
      busyLabel="Processing..."
      labelClass="font-semibold"
      [searchFn]="scannerSearch.bind(this)"
      (scanResult)="onScanResult($event)"
      (scanError)="onScanError($event)"
      class="hh-scanner"
    ></uni-scanner-input>

    <div *ngIf="errorMessage" class="text-sm text-red-500">{{ errorMessage }}</div>

    <div *ngIf="hasAccountOwnedMatches" class="flex items-center gap-2 mt-1">
      <p-checkbox [(ngModel)]="allowNonAccountOwned" [binary]="true"></p-checkbox>
      <label class="text-sm">Allow non-Account-Owned items</label>
    </div>
  </div>

  <!-- Match list -->
  <div class="flex items-center justify-between">
    <div class="text-sm font-semibold">Matching inventory</div>
    <div class="text-xs opacity-60">{{ matches.length }} candidate{{ matches.length !== 1 ? 's' : '' }}</div>
  </div>

  <div class="flex flex-col gap-2 overflow-y-auto flex-1">
    <div
      *ngFor="let match of matches"
      class="np-card flex flex-col gap-2"
      [class.cursor-pointer]="user.isPullAdmin"
      (click)="onTapMatch(match)"
    >
      <div class="flex items-start justify-between gap-2">
        <div class="flex flex-col gap-0.5 min-w-0">
          <div class="text-sm font-semibold">
            {{ match.itemDetail.product?.productType?.manufacturer?.name }}
            <span class="opacity-50">·</span>
            {{ match.itemDetail.product?.productType?.style }}
          </div>
          <div class="text-xs opacity-80">{{ match.itemDetail.product?.productType?.description }}</div>
          <div class="text-xs opacity-70">{{ match.itemDetail.product?.featureChoicesExtract }}</div>
        </div>
        <span class="np-badge shrink-0" [ngClass]="fitnessBadgeClass(match.fitnessRank)">
          {{ match.fitness }}
        </span>
      </div>
      <div class="flex items-center justify-between text-xs">
        <span>
          <span class="opacity-60">Bin:</span> {{ match.itemDetail.itemBin?.name || '—' }}
        </span>
        <span class="opacity-60">{{ match.itemDetail.id }}</span>
      </div>
    </div>

    <div *ngIf="matches.length === 0" class="text-center py-8 opacity-50">
      No matching inventory found
    </div>
  </div>
</div>
